import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { Loader2 } from "lucide-react";

export default function SourceRouter() {
  const { sourceCode } = useParams<{ sourceCode: string }>();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const validateAndRedirect = async () => {
      if (!sourceCode) {
        navigate('/try');
        return;
      }

      try {
        // Validate the source code
        const { data, error } = await supabase.functions.invoke('validate-qr-source', {
          body: { sourceCode }
        });

        if (error || !data?.valid) {
          console.warn('[SourceRouter] Invalid source code:', sourceCode);
          // Still redirect to /try but without source attribution
          navigate('/try');
          return;
        }

        // Valid source - redirect with attribution
        navigate(`/try?source=${data.source.code}`);
      } catch (err) {
        console.error('[SourceRouter] Error:', err);
        // On error, redirect to /try without source
        navigate('/try');
      }
    };

    validateAndRedirect();
  }, [sourceCode, navigate]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <p className="text-destructive mb-4">{error}</p>
          <button 
            onClick={() => navigate('/try')}
            className="text-primary underline"
          >
            Continue anyway
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="flex items-center gap-2">
        <Loader2 className="h-6 w-6 animate-spin" />
        <span>Redirecting...</span>
      </div>
    </div>
  );
}
